import { Link } from 'react-router-dom';
import './Auth.css';

function SignUpPage() {
  return (
    <div className="auth-page">
      <div className="auth-container">
        <h1 className="auth-title">R.U.S.H.</h1>
        <p className="auth-subtitle">Create Account</p>
        <p className="auth-description">Registration is not open yet.</p>
        <p className="auth-footer">
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}

export default SignUpPage;
